import extractHostname from './extractHostname';

const cmsHost = extractHostname(process.env.GATSBY_BASE_URL);

function isExternalLink(url) {
  const hostname = extractHostname(url)
  return !!(hostname && hostname !== cmsHost)
}

export default isExternalLink
